import { createChecklistRequirement } from './createRequirementThunk';
export default createChecklistRequirement;
